(function(){
  function ready(fn){ if(document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function(){
    var root = document.querySelector('[data-course-overview]');
    if (!root) return;

    // Progressive play cues for the two Vimeo samples. If JS is unavailable,
    // the buttons remain hidden and the native Vimeo player still works.
    root.querySelectorAll('.bcrc-lng-sample-frame').forEach(function(frame){
      var button = frame.querySelector('.bcrc-video-play');
      var iframe = frame.querySelector('iframe');
      if (!button || !iframe) return;

      frame.classList.add('is-enhanced');
      button.addEventListener('click', function(){
        var source = iframe.getAttribute('src');
        if (!source) return;

        frame.classList.add('is-playing');
        button.setAttribute('aria-hidden', 'true');
        button.setAttribute('tabindex', '-1');

        if (source.indexOf('autoplay=1') === -1) {
          iframe.setAttribute('src', source + (source.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1');
        }
      });
    });

    // FAQs use native details/summary.
    // Tabbed proof panels
    var tabs = root.querySelectorAll('.bcrc-proof-tab');
    var panels = {
      retakers: root.querySelector('#bcrc-proof-retakers'),
      switchers: root.querySelector('#bcrc-proof-switchers'),
      newpassers: root.querySelector('#bcrc-proof-newpassers')
    };
    tabs.forEach(function(tab){
      tab.setAttribute('aria-pressed', String(tab.classList.contains('active')));
      tab.setAttribute('aria-controls', 'bcrc-proof-' + tab.getAttribute('data-tab'));
      tab.addEventListener('click', function(){
        tabs.forEach(function(t){ t.classList.remove('active'); t.setAttribute('aria-pressed', 'false'); });
        Object.keys(panels).forEach(function(k){ if (panels[k]) panels[k].classList.remove('active'); });
        this.classList.add('active'); this.setAttribute('aria-pressed', 'true');
        var which = this.getAttribute('data-tab');
        if (panels[which]) panels[which].classList.add('active');
      });
    });
  });
})();
